import * as React from 'react';
import * as RV from '../i4Reports/PowerBIReportVisual';
import queryString from 'query-string'


export default class AppWithQuery extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);
        this.state = { reportId : null, visualId : null, pageName:null, workspaceId:null, vesselGroupName: null, vesselName: null, date: null}
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        var reportId = values.reportId;
        var visualId = values.visualId;
        var pageName = values.pageName;
        var workspaceId = values.workspaceId;
        var username = values.username;
        var userToken = values.userToken;
        var vesselGroupName = null;
        var imo = null;
        var date = null;
        if (values.vesselGroupName != null) {
            vesselGroupName = values.vesselGroupName
        }
        if (values.imo != null) {
            imo = values.imo
        }
        if (values.date != null) {
            date = values.date
        }


        this.setState({ reportId, visualId, pageName, workspaceId, vesselGroupName, imo, date, username, userToken});
    }

    

    render() {
        var content = this.state.reportId != null ? <RV.default workspaceId={this.state.workspaceId} pageName={this.state.pageName} username={this.state.username} visualId={this.state.visualId} vesselGroupName={this.state.vesselGroupName} imo={this.state.imo} date={this.state.date} userToken={this.state.userToken} reportId={this.state.reportId} /> : <div >

        </div>;
        return (
            <div className='powerbi-div-style'>
                {content}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/app/AppWithQuery.tsx